module.exports = __webpack_public_path__ + "static/media/UGoing_Logo.db04ece9.png";